import { Main } from "fleet/controller/main";
import { connect } from "react-redux";
import { storesReady } from "redux-store";
import * as Auth from "redux-store/auth/selectors";
import * as FeatureFlags from "redux-store/feature-flags/selectors";
import * as User from "redux-store/users/selectors";

function mapStateToProps(state) {
  const user = Auth.getAuthUser(state);
  const isAdmin = User.isAdmin(user);

  const auth = Auth.authSelector(state);
  const isAuthenticated = Auth.isAuthenticated(auth);
  const featureFlags = FeatureFlags.getFeatureFlags(state);

  const storesLoaded = storesReady(state.global.auth);

  return {
    featureFlags,
    isAdmin,
    isAuthenticated,
    storesLoaded,
    user,
  };
}

const ConnectedMain = connect(mapStateToProps)(Main);

export { ConnectedMain };
